Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "cflabelprinters3";
exports.labelBodyText = "cflabelprinters3 Body";
exports.receiptPrinterStorageKey = "qzTrayPrinter"
exports.sampleLabelBtnTest = "btn-test-sample"
exports.pageTitleTest = "page-title"

exports.btnExampleTitle = "CLICK ME";
// Customizable Area End